import { useRef, useState, useEffect } from "react";
import { subirFotoBase64 } from "./sigteFotos";

// Portado de SignaturePad en sigte-prototipo.jsx:352-423 (captura de trazo
// con canvas, mouse+touch, toDataURL()). Unico cambio real: guardar() ya no
// entrega el base64 crudo al padre - lo sube al staging de fotos y entrega
// el filename resultante. El base64 nunca sale de este componente.
export function SigteSignaturePad(p) {
  var canvasRef = useRef(null);
  var dibujando = useRef(false);
  var [trazo, setTrazo] = useState(false);
  var [subiendo, setSubiendo] = useState(false);
  var [err, setErr] = useState("");

  useEffect(function () {
    var c = canvasRef.current;
    if (!c) return;
    var ctx = c.getContext("2d");
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#1c1c1e";
  }, []);

  function pos(e) {
    var r = canvasRef.current.getBoundingClientRect();
    var pt = e.touches ? e.touches[0] : e;
    return { x: pt.clientX - r.left, y: pt.clientY - r.top };
  }
  function iniciar(e) {
    e.preventDefault();
    dibujando.current = true;
    var ctx = canvasRef.current.getContext("2d");
    var xy = pos(e);
    ctx.beginPath();
    ctx.moveTo(xy.x, xy.y);
  }
  function mover(e) {
    if (!dibujando.current) return;
    e.preventDefault();
    var ctx = canvasRef.current.getContext("2d");
    var xy = pos(e);
    ctx.lineTo(xy.x, xy.y);
    ctx.stroke();
    setTrazo(true);
  }
  function terminar() { dibujando.current = false; }
  function limpiar() {
    var c = canvasRef.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setTrazo(false);
    setErr("");
    p.onSave(null);
  }
  function guardar() {
    setErr(""); setSubiendo(true);
    subirFotoBase64(canvasRef.current.toDataURL())
      .then(function (filename) { p.onSave(filename); setSubiendo(false); })
      .catch(function (e) { setErr(e.message); setSubiendo(false); });
  }

  return (
    <div>
      {p.titulo ? (
        <div style={{ marginBottom: 8, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <p style={{ margin: 0, fontSize: 13, fontWeight: 600, color: "#0f172a" }}>{p.titulo}</p>
          {p.guardada ? <span style={{ fontSize: 11, fontWeight: 600, color: "#059669" }}>Firmada</span> : null}
        </div>
      ) : null}
      <canvas
        ref={canvasRef} width={280} height={110}
        style={{ width: "100%", touchAction: "none", borderRadius: 12, border: "1px dashed #cbd5e1", background: "#f8fafc" }}
        onMouseDown={iniciar} onMouseMove={mover} onMouseUp={terminar} onMouseLeave={terminar}
        onTouchStart={iniciar} onTouchMove={mover} onTouchEnd={terminar}
      />
      {err ? <p style={{ margin: "4px 0 0", fontSize: 11, color: "#dc2626" }}>{err}</p> : null}
      <div style={{ marginTop: 8, display: "flex", gap: 8 }}>
        <button type="button" onClick={limpiar} style={{ padding: "6px 10px", borderRadius: 8, border: "none", background: "none", color: "#64748b", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>Borrar</button>
        <button type="button" onClick={guardar} disabled={!trazo || p.deshabilitado || subiendo}
          style={{ padding: "6px 14px", borderRadius: 8, border: "none", background: "#0f172a", color: "#fff", fontSize: 12, fontWeight: 600, cursor: (!trazo || p.deshabilitado) ? "default" : "pointer", opacity: (!trazo || p.deshabilitado || subiendo) ? 0.4 : 1 }}>
          {subiendo ? "Subiendo..." : "Guardar firma"}
        </button>
      </div>
    </div>
  );
}
